/**
 *
 * @param {Number} value
 * @param {Object} stampDuties
 * @param {String} state
 * @param {Boolean} isSdAvailable
 *
 * @returns {Number}
 */
function getSdSellPrice(value, stampDuties, state, isSdAvailable = true) {

    return (
        (isSdAvailable
            ? (Number(value || 0) / 1.1) *
              (Number(stampDuties[getSdState(state)] || 0) / 100)
            : 0) + Number(value || 0)
    );
}

/**
 *
 * @param {Number} id
 * @param {Array} options
 * @param {String} state
 *
 * @returns Number
 */
function getMinAmountLocalised(id, options, state) {
    const option = options.find(option => {
        return option.value == id;
    });

    return option ? Number(option.min || 0) : 0;
}

/**
 *
 * @param {Number} price
 * @param {Number} sdFactor - pre computed sd factor from backend based on the current state
 * @param {String} state
 *
 * @returns {Number}
 */
function getRetailPrice(price, sdFactor, state) {
    // sd factor is 1.1 * sd if sd available else 1.1
    return (Number(price || 0) / Number(sdFactor || 0)) * 1.1;
}

function getSdState(state) {
    if (state) {
        switch (state.toUpperCase().trim()) {
            case "WA":
                return "wa_sd";
            case "QLD":
                return "qld_sd";
            case "NT":
                return "nt_sd";
            case "TAS":
                return "tas_sd";
            case "NSW":
                return "nsw_sd";
            case "VIC":
                return "vic_sd";
            case "ACT":
                return "act_sd";
            case "SA":
                return "sa_sd";
        }
    }
    return ""
}

export { getSdSellPrice, getRetailPrice, getMinAmountLocalised };
